import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const CART_DISCOUNT_URL = `${CART_URL}/discount-code`;

export async function addDiscountCode(
  discountCode: string
): Promise<{ data: HttpCartDto }> {
  return httpClient.post(CART_DISCOUNT_URL, { discountCode });
}
